<template>
    <div class="center" :class="msj != 2? 'fondo-login' : ''">
      <vs-dialog :blur="msj==2" not-close prevent-close v-model="active">
        <template #header>
         <div class="text-center">
          <img src="@/assets/img/LOGO.svg" class="mt-4 mb-0"  width="100" />
          <img src="@/assets/img/letras.svg" class="mt-3 mb-2 d-block" width="150" />
         </div>
        </template>

        <div class="d-flex justify-content-center pb-5">
          <div style="width: 83%">
            <div class="text-center mb-5">
              <h2 style="font-weight: bold">{{msj == 1? '¡Bienvenido!' : 'Tiempo expirado'}}</h2>
            </div>
            <vs-input
              v-model.trim="usuario.login"
              placeholder="Usuario"
              v-on:keyup.enter="handleIniciarSesion"
              :state=" (validacionUsername = getValidationForm('username',validaciones)) ? 'danger' : ''"
              @blur="individualValidateForm('username',usuario.login,validaciones)"
            >
              <template #icon>
                <i class="fas fa-user"></i>
              </template>
              <template #message-danger v-if="validacionUsername" >
                  {{validacionUsername.msg}}
              </template>
            </vs-input>
            <vs-input
              type="password"
              v-model.trim="usuario.password"
              placeholder="Contraseña"
              v-on:keyup.enter="handleIniciarSesion"
              :state=" (validacionPassoword = getValidationForm('password',validaciones)) ? 'danger' : ''"
              @blur="individualValidateForm('password',usuario.password,validaciones)"
            >
              <template #icon>
                <i class="fas fa-lock"></i>
              </template>
              <template #message-danger v-if="validacionPassoword" >
                  {{validacionPassoword.msg}}
              </template>
            </vs-input>
            <vs-button
              @click="handleIniciarSesion()"
              class="btn-primary-variant mb-0 mt-4 mx-0"
              :loading="load"
              block
            >
              Iniciar sesión
            </vs-button>
          </div>
        </div>

        <template #footer>
          <div class="footer-dialog text-center" v-if="false">
            <a class="otrosLinks" href="https://siahe.haciendachiapas.gob.mx/SIGHA/2025/Presupuesto/Principal/login">Ingresa al SIGHA aquí</a>
          </div>
          <div class="footer-dialog text-center pt-3 pb-2">
            <a @click="verModal = true" class="avisoPrivacidad">Aviso de privacidad</a>
          </div>
        </template>
      </vs-dialog>
       <!-- modal de aviso de privacidad -->
       <div class="aviso_">
        <px-modal 
            v-show="verModal" 
            @verModal="verModal = $event" 
            idModal="ModalAviso" 
            textHeader="Avíso de Privacidad"
            modalWidth="900px"
        >
            <p class="border-bottom pb-4 m-0">
              La Subsecretaría de Egresos de la Secretaría de Finanzas, es responsable del tratamiento de los datos personales que nos proporcione; mismos que serán protegidos conforme a lo dispuesto por la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados del Estado de Chiapas. Los datos personales recabados en el Sistema de Anteproyecto de Egresos (SAPE), versión Organismo Público es responsabilidad de cada Ente Público a través del Administrador del SIGHA, mismo que debe ser utilizado únicamente para la creación de las cuentas de los Usuarios Operativos (nombre, área de adscripción) y para la generación de documentos Oficiales a través del Sistema en mención. Se le informa que no se realizarán transferencias de sus datos personales. Para mayor información acerca del tratamiento, así como para el acceso, rectificación, cancelación y oposición en materia de datos personales, se pone a su disposición el aviso de privacidad integral para su consulta en internet en la dirección electrónica siguiente: <a target="_blank" href="https://www.finanzaschiapas.gob.mx/SitioNuevo/aviso-de-privacidad"> https://www.finanzaschiapas.gob.mx/SitioNuevo/aviso-de-privacidad </a>
            </p>
            <div class="d-flex justify-content-end pt-2">
                <vs-button class="btn-primary-o px-5" @click="verModal=false">Cerrar</vs-button>
            </div>
        </px-modal>
      </div>
    </div>
</template>
<script>
    import FormValidation from '@/mixins/formulario/FormValidationMixin'
    import mapHelper from '@/store/modules/common/map-helper'
    import NotificationMixin from '@/mixins/ResourceNotificationMixin.js'
    import PxModal from '@/components/PxModal.vue'
    export default {
      components: { PxModal },
        name:'Login',
        mixins:[FormValidation,NotificationMixin],
        data(){
            return{
              verModal: false,
                active: false,
                usuario:{login:'',password:''},
                validaciones:[
                    {
                        input:"login", 
                        validaciones : [             
                                v => !!v || 'El usuario es requerido',
                            ],
                        error:false,
                        msg:''
                    },
                    {
                        input:"password", 
                        validaciones : [             
                                v => !!v || 'La contraseña es requerida',
                            ],
                        error:false,
                        msg:''
                    }
                    
                ],
                load:false
            }
        },
        methods:{
            async handleIniciarSesion(){
                // if(!this.validateForm(this.usuario,this.validaciones)){
                //   return
                // }
                try{

                  await this.$store.dispatch(mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.logIn,this.usuario);
                  if(this.msj == 2) {
                    // console.log('logiiin');
                    this.$emit('login', false);
                  }else{
                    this.$router.push({ name: 'Inicio' })
                  }
                }catch(error){
                  console.log("error en login:"+error)
                  this.openNotification(
                            null, //posición
                            'danger-sh',  // color
                            `<i class="fas fa-check-circle"></i>`, // icono de fontawesome
                            'Notificación', // titulo 
                            error,
                            '8000' // contenido
                        );
                }
            }
        },
        created() {
          setTimeout(() => {this.active = true}, 100);
      },
      props:{
        msj: {
          type: Number, 
          default: 1
        }
      }
    }
</script>
<style scoped>
  .vs-dialog-content {
    background: rgba(0, 0, 0, var(--vs-background-opacity));
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: var(--vs-zindex-2);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    max-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 0;
    padding-bottom: 0;
  }

  .fondo-login {
     background: linear-gradient(rgba(46,148,134,.73),rgba(46,148,134,.82)),url('../../assets/img/junta.jpg') !important;
    /* background-color: #C62855; */
    background-size: auto, auto;
    background-size: cover !important;
    background-repeat: no-repeat;
    height: 100vh;
}

.vs-select-content, .vs-input-parent {
  margin: 0 0 .5rem 0;
}

.avisoPrivacidad{
  color: #817e7e;
  font-size: .8rem;
  cursor: pointer;
}
.otrosLinks{
  color: #7B3349;
  font-size: 1rem;
  cursor: pointer;
  transition: ease all .2s;
  text-decoration: none;
}
.otrosLinks:hover{
  font-weight: bold;
}
</style>